/* eslint-disable */
import {Service} from 'components/Shared/server';
import {ChangeOrderModel} from 'models/ChangeOrderModel';
import {OtherQuestionModel} from 'models/OtherQuestionModel';
import {DeliveryQuestionModel} from 'models/DeliveryQuestionModel';
import {ReturnModel} from 'models/ReturnModel';
import {ClaimsModel} from 'models/ClaimsModel';
import {InquiryRequestModel} from 'models/InquiryRequestModel';
import {PriceMatchRequestModel} from 'models/PriceMatchRequestModel';
import {PriceMatchExistingOrderRequestModel} from 'models/PriceMatchExistingOrderRequestModel';
import {ShippingDamageModel} from 'models/ShippingDamageModel';
import {FileUploadModel} from 'models/FileUploadModel';
import {CreateRequestModel} from 'models/CreateRequestModel';


export const routePostSendChange = () => `/api/support/sendchange`;
export function postSendChange(request: ChangeOrderModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendChange(),
    body: request
  });
}

export const routePostSendOtherQuestion = () => `/api/support/sendotherquestion`;
export function postSendOtherQuestion(request: OtherQuestionModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendOtherQuestion(),
    body: request
  });
}

export const routePostSendDeliveryQuestion = () => `/api/support/senddeliveryquestion`;
export function postSendDeliveryQuestion(request: DeliveryQuestionModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendDeliveryQuestion(),
    body: request
  });
}

export const routePostSendReturn = () => `/api/support/sendreturn`;
export function postSendReturn(request: ReturnModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendReturn(),
    body: request
  });
}

export const routePostSendClaims = () => `/api/support/sendclaims`;
export function postSendClaims(request: ClaimsModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendClaims(),
    body: request
  });
}

export const routePostSendProductQuestion = () => `/api/support/sendproductquestion`;
export function postSendProductQuestion(request: InquiryRequestModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendProductQuestion(),
    body: request
  });
}

export const routePostSendPriceMatchQuestion = () => `/api/support/sendpricematchquestion`;
export function postSendPriceMatchQuestion(request: PriceMatchRequestModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendPriceMatchQuestion(),
    body: request
  });
}

export const routePostSendExistingOrderPriceMatchQuestion = () => `/api/support/sendexistingorderpricematchquestion`;
export function postSendExistingOrderPriceMatchQuestion(request: PriceMatchExistingOrderRequestModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendExistingOrderPriceMatchQuestion(),
    body: request
  });
}

export const routePostSendShippingDamage = () => `/api/support/sendshipping`;
export function postSendShippingDamage(request: ShippingDamageModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendShippingDamage(),
    body: request
  });
}

export const routePostSendQuotationRequest = () => `/api/support/sendquotationrequest`;
export function postSendQuotationRequest(request: InquiryRequestModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostSendQuotationRequest(),
    body: request
  });
}

export const routePostUploadImage = () => `/api/support/uploadimage`;
export function postUploadImage(request: FileUploadModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostUploadImage(),
    body: request
  });
}

export const routePostCreateRequest = () => `/api/support/requests`;
export function postCreateRequest(request: CreateRequestModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostCreateRequest(),
    body: request
  });
}

export const routePostUploadFile = () => `/api/support/uploads`;
export function postUploadFile(file: FileUploadModel): Promise<Response> {
  return Service.post<Response>({
    url: routePostUploadFile(),
    body: file
  });
}
